class AnnouncementBar extends HTMLElement {
  constructor() {
    super()

    this.swiperEl = this.querySelector('swiper-container')
    this._nostoObserver = null
  }

  connectedCallback() {
    this.swiperEl.addEventListener('swiperslidechangetransitionend', () => {
      this.setSlidesA11y(this.swiperEl)
    })

    this._checkForInjectedNostoBanner()
  }

  _checkForInjectedNostoBanner() {
    if (document.getElementById('nosto-announcement')) {
      this._dispatchReadyEvent()
      return
    }
    if (this._nostoObserver) return
    this._nostoObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        const { target } = mutation
        if (
          target.classList.contains('nosto-slider') &&
          target.classList.contains('slick-initialized')
        ) {
          this._dispatchReadyEvent()
          this._nostoObserver.disconnect()
          this._nostoObserver = null
          return
        }
      }
    })
    this._nostoObserver.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  _dispatchReadyEvent() {
    const mainMenu = document.querySelector('main-menu')
    if (mainMenu) {
      mainMenu.dispatchEvent(
        new CustomEvent('announcement-bar::ready', { bubbles: true })
      )
    }
  }

  disconnectedCallback() {
    if (this._nostoObserver) {
      this._nostoObserver.disconnect()
      this._nostoObserver = null
    }
  }

  setSlidesA11y(swiperEl) {
    swiperEl.querySelectorAll('swiper-slide').forEach((slide) => {
      if (slide.classList.contains('swiper-slide-active')) {
        slide.removeAttribute('inert')
      } else {
        slide.setAttribute('inert', '')
      }
    })
  }
}
window.customElements.define('announcement-bar', AnnouncementBar)
